import { cn } from '@/lib/cn';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface LoadingSpinnerProps {
  size?: SpinnerSize;
  text?: string;
  className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-[3px]',
  lg: 'h-12 w-12 border-4',
};

export function LoadingSpinner({ size = 'md', text, className }: LoadingSpinnerProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-3', className)}
      role="status"
      aria-label={text ?? 'Loading'}
    >
      <div
        className={cn(
          'animate-spin rounded-full border-[#e0e0e0] border-t-[#6B0F1A]',
          sizeClasses[size],
        )}
      />
      {text && <p className="text-sm text-[#666]">{text}</p>}
    </div>
  );
}
